// extracted by mini-css-extract-plugin
module.exports = {"root":"Resend_root__tjV89","btn":"Resend_btn__1Keug","counter":"Resend_counter__5IOX8","darkText":"Resend_darkText__2KKw7"};